// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2GoAB","badgeList":"styles_badgeList__2awmi"};